import { Component, ChangeDetectionStrategy } from "@angular/core";
import { SeriesVerticalComponent, BarChartModule, TooltipModule } from "@swimlane/ngx-charts";

@Component({
    selector: "g[kilowant-charts-series-vertical-home-accept-offer]",
    templateUrl: "../../../html/chart/kilowant-charts-series-vertical-home-accept-offer.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [BarChartModule, TooltipModule]
})
export class KilowantSeriesVerticalHomeAcceptOfferComponent extends SeriesVerticalComponent {
    ngOnInit(): void {
    }

    ngOnChanges(): void {
        this.update();
    }

    /**
     * True when the bar's underlying DataItem is marked as inactive.
     * Defensive: also checks `bar.isInactive` in case a future ngx-charts
     * version lifts the flag onto the rendered bar object.
     */
    isBarInactive(bar: any): boolean {
        if (bar == null) { return false; }
        if (bar.data != null && bar.data.isInactive === true) { return true; }
        if (bar.isInactive === true) { return true; }
        return false;
    }
}